import { convertImageToGrayScale } from './colors';

export const extractSvgDimensions = (svgText: string): { width: number; height: number } => {
  const matchHeight = svgText.match(/height=\"(\d+)/m);
  const height = matchHeight && matchHeight[1] ? parseInt(matchHeight[1], 10) : 200;
  const matchWidth = svgText.match(/width=\"(\d+)/m);
  const width = matchWidth && matchWidth[1] ? parseInt(matchWidth[1], 10) : 200;
  return { width, height };
};

export interface SVGToPNGResult {
  dataUrl: string;
  width: number;
  height: number
}

export const svgToPng = (
  svgText: string,
  margin = 0,
  grayscale = false,
): Promise<SVGToPNGResult | undefined> => {
  return new Promise(function (resolve, reject) {
    try {
      const domUrl = window.URL || window.webkitURL || window;
      if (!domUrl) {
        throw new Error('SVG to PNG not supported!');
      }
      const { width, height } = extractSvgDimensions(svgText);
      if (!svgText.match(/xmlns=\"/im)) {
        svgText = svgText.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" ');
      }

      const canvas = document.createElement('canvas');
      canvas.width = width + margin * 2;
      canvas.height = height + margin * 2;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        throw new Error('cant create canvas context!');
      }
      const svg = new Blob([svgText], {
        type: 'image/svg+xml;charset=utf-8',
      });
      const url = domUrl.createObjectURL(svg);
      const img = new Image();

      img.onload = () => {
        ctx.drawImage(img, margin, margin);

        if (grayscale) {
          convertImageToGrayScale(ctx, canvas.width, canvas.height);
        }
        domUrl.revokeObjectURL(url);
        resolve({ dataUrl: canvas.toDataURL(), width, height } as SVGToPNGResult);
      };
      img.onerror = (e) => {
        console.log('error', e);
      };
      img.src = url;
    } catch (err) {
      console.error('failed to convert svg to png!' + err);
      resolve(undefined);
    }
  })
};
